import React, { useState } from "react";
import { MdOutlineCancel } from "react-icons/md";
import { BsFillCreditCardFill } from "react-icons/bs";
import '../../assets/css/CreateGamePayment.css';
import { FaCcVisa, FaCcMastercard, FaCcAmex, FaCcJcb } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { apiHandler } from "../../assets/api";
import { endpoint } from "../../assets/api/endpoint";
import { useSelector } from "react-redux";
import { toast } from 'react-toastify';

const CreateGamePayment = () => {
    const [country, setCountry] = useState("India");
    const [saveInfo, setSaveInfo] = useState(false);
    const location = useLocation();
    const { filterId, plans } = location.state || {};
    const { accessToken } = useSelector((state) => state?.loginInfo.accessToken);
    const filterPlan = plans.filter((item) => item.id == filterId);

    const onSetUP = async () => {
        try {
            const result = await apiHandler({
                url: `${endpoint.SUBSCRIPTION_PAYMENT_API}?id=${filterId}`,
                method: "POST",
                authToken: accessToken,
            });
            // console.log('result', result);
        } catch (error) {
            toast.error("An error occurred while applying filters.");
        }

    }

    return (
        <div className="payment-container">
            <div className="payment-box">
                <div className="payment-header">
                    <h2>How your trial works</h2>
                    <button className="cancel-btn">
                        <MdOutlineCancel size={22} />
                    </button>
                </div>
                <p className="payment-description">
                    { filterPlan[0]?.planDetails?.details[0]  }
                    {filterPlan[0]?.planDetails?.details[1]}
                </p>
                {/* Payment Button */}
                <button className="pay-btn">
                    Pay with <b>Link</b>
                </button>

                <p className="divider-text">Or use</p>

                <div className="d-flex justify-content-between">
                    <h6>Card Information</h6>
                    <h6>Scan Card</h6>
                </div>
                <div className="input-group">
                    <div className="card-input">
                        <input type="text" placeholder="Card number" />
                        <div className="icon-container">
                            <FaCcVisa className="payment-icon visa" />
                            <FaCcMastercard className="payment-icon mastercard" />
                            <FaCcAmex className="payment-icon amex" />
                            <FaCcJcb className="payment-icon jcb" />
                        </div>

                    </div>
                </div>

                <div className="input-row">
                    <input type="text" placeholder="MM / YY" className="half-input" />
                    <input type="text" placeholder="CVC" className="half-input" />
                </div>

                <div className="input-group">
                    <label>Billing Address</label>
                    <select value={country} onChange={(e) => setCountry(e.target.value)}>
                        <option>India</option>
                        <option>USA</option>
                        <option>UK</option>
                        <option>Canada</option>
                    </select>
                </div>

                <div className="checkbox-group">
                    <input type="checkbox" checked={saveInfo} onChange={() => setSaveInfo(!saveInfo)} />
                    <span>Save your info for secure 1-click checkout with Link</span>
                </div>

                <button className="setup-btn" onClick={onSetUP}>Set up</button>
            </div>
        </div>
    );
};

export default CreateGamePayment;
